import { 
  dimensionMetricsTrend, 
  dimensionMetricsTrendAcc, 
  dimensionMetricsTrendXh, 
  downLoadDayPerformanceTable, 
  downLoadDayPerformanceTableAcc, 
  downLoadDayPerformanceTableXh, 
  getDailyKeyPerformanceMetricAcc, 
  getDailyKeyPerformanceMetricXh, 
  getDailyKeyPerformanceMetrics, 
  getDayPerformanceTable, 
  getDayPerformanceTableAcc, 
  getDayPerformanceTableXh, 
  getMetricsUsers, 
  getMetricsUsersAcc, 
  getMetricsUsersXh, 
  getRegionCountriesZone, 
  getRegionCountriesZoneAcc, 
  getRegionCountriesZoneXh, 
  loadMetricsTrend, 
  loadMetricsTrendAcc, 
  loadMetricsTrendXh,
} from "@/pages/dashboard/services/overview";

// normal 最普通的daily页面请求api
// xh daily 去小号页面的api
// daily 汇总版本 去小号 页面的api
const dailyRequest:any = {
  getDailyKeyPerformanceMetrics: {
    normal: getDailyKeyPerformanceMetrics,
    xh: getDailyKeyPerformanceMetricXh,
    acc: getDailyKeyPerformanceMetricAcc,
  },
  loadMetricsTrend: {
    normal: loadMetricsTrend,
    xh: loadMetricsTrendXh,
    acc: loadMetricsTrendAcc,
  },
  dimensionMetricsTrend: {
    normal: dimensionMetricsTrend,
    xh: dimensionMetricsTrendXh,
    acc: dimensionMetricsTrendAcc,
  },
  getDayPerformanceTable: {
    normal: getDayPerformanceTable,
    xh: getDayPerformanceTableXh,
    acc: getDayPerformanceTableAcc,
  },
  downLoadDayPerformanceTable: {
    normal: downLoadDayPerformanceTable,
    xh: downLoadDayPerformanceTableXh,
    acc: downLoadDayPerformanceTableAcc,
  },
  getMetricsUsers: {
    normal: getMetricsUsers,
    xh: getMetricsUsersXh,
    acc: getMetricsUsersAcc,
  },
  getRegionCountriesZone: {
    normal: getRegionCountriesZone,
    xh: getRegionCountriesZoneXh,
    acc: getRegionCountriesZoneAcc,
  }
}

export {
  dailyRequest
}
